import { useState } from "react";
import "../styles//components/quantitySelector.css";
import Icons from "../assets/icons/icons";
import { RavenInputField } from "@ravenpay/raven-bank-ui";
import { useDarkMode } from "../utils/themes/useDarkMode";

interface QuantitySelectorProps {
  quantity?: number;
  setQuantity: (value: number) => void;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  setQuantity,
}) => {
  const handleIncrease = () => {
    setQuantity((quantity ?? 0) + 1);
  };
  const [theme, toggleTheme] = useDarkMode(localStorage.getItem("theme"));

  const handleDecrease = () => {
    if (Number(quantity) > 1) {
      const newQuantity = (quantity ?? 0) > 1 ? (quantity ?? 0) - 1 : 0;
      setQuantity(newQuantity);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (Number(value) >= 1) {
      if (value === "") {
        setQuantity(0);
        return;
      }

      const parsedValue = parseInt(value, 10);
      if (!isNaN(parsedValue) && parsedValue >= 1) {
        setQuantity(parsedValue);
      }
    }
  };

  return (
    <div className="quantity_selector_general_wrap">
      <div
        className="quantity-control-button-left grey-bg"
        onClick={handleDecrease}
        style={{ cursor: Number(quantity) > 1 ? "pointer" : "default" }}
      >
        <figure>
          {Icons.minusIcon(theme === "light" ? "#020202" : "#ffffff")}
        </figure>
      </div>
      <div className="quantity-input-button grey-white-color-white">
        <RavenInputField
          className="input"
          onChange={handleInputChange}
          value={quantity}
          placeholder=" "
        />
      </div>
      <div
        className="quantity-control-button-right grey-bg"
        onClick={handleIncrease}
        style={{ cursor: "pointer" }}
      >
        <figure>
          {Icons.plusIcon(theme === "light" ? "#020202" : "#ffffff")}
        </figure>
      </div>
    </div>
  );
};

export default QuantitySelector;
